import styled from 'styled-components'
import LevelRatingQuestionLabelLayout from '../LevelRatingQuestionLabelLayout'
import InputAnswerItemDesktop, {
  InputAnswerItemDesktopProps,
} from './InputAnswerItem.desktop'

interface InputQuestionDesktopProps {
  questioonLabel: string
  answerList: InputAnswerItemDesktopProps[]
}

const InputQuestionDesktop = ({
  questioonLabel,
  answerList,
}: InputQuestionDesktopProps) => {
  return (
    <StyledWrapper>
      <LevelRatingQuestionLabelLayout label={questioonLabel}>
        <div className="input-list">
          {answerList.map(
            (
              { answer, questionId, questionSeq, inputQuestionSubject },
              index,
            ) => {
              return (
                <InputAnswerItemDesktop
                  answer={answer}
                  key={`${answer.id}-${index}`}
                  questionId={questionId}
                  inputQuestionSubject={inputQuestionSubject}
                  questionSeq={questionSeq}
                />
              )
            },
          )}
        </div>
      </LevelRatingQuestionLabelLayout>
    </StyledWrapper>
  )
}

export default InputQuestionDesktop

const StyledWrapper = styled.div`
  margin-bottom: 44px;

  .input-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
`
